export const getCardId = (data?: {
  patientByCardId?: {
    patient?: { card?: { id?: string } };
    passportId?: string;
  };
}): string | undefined => {
  if (!data?.patientByCardId?.patient) {
    return undefined;
  }

  const { patient, passportId } = data.patientByCardId;
  return patient.card?.id ? patient.card.id : passportId;
};

const NA = "-";
export function formatCardId(cardId?: string): string {
  if (!cardId) {
    return NA;
  }

  return `${cardId.substr(0, 4)} ${cardId.substr(4, 4)} ${cardId.substr(8, 4)}`;
}
